module.exports = __webpack_public_path__ + "media/confettiSound.62af80b3.mp3";